import { lazy } from 'react';

export const PlayerUpdateGamanzaBlockForm = lazy(
  () => import('./PlayerUpdateGamanzaBlockForm'),
);
